import {SPORT_TYPES} from "../../app/consts";

export const SCHEMA_TYPE = {
  breadcrumbList: 'BreadcrumbList',
  person: 'Person',
  organization: 'Organization',
  sportsOrganization: 'SportsOrganization',
  sportsTeam: 'SportsTeam',
  sportsEvent: 'SportsEvent',
  place: 'Place',
  postalAddress: 'PostalAddress',
  nationality: 'Country',
  thing: 'Thing',
  faqPage: 'FAQPage',
  question: 'Question',
  answer: 'Answer',
  website: 'WebSite',
  article: 'Article',
  review: 'Review'
}

export const SCHEMA_EVENT_STATUS = {
  scheduled: 'https://schema.org/EventScheduled'
}

export const ENTITY_LOGO_SIZE = {
  width: 250,
  height: 250
}

export const SCHEMA_GAME_DURATION_BY_SPORT = {
  [SPORT_TYPES.football]: 105,
  [SPORT_TYPES.basketball]: 150,
  [SPORT_TYPES.hockey]: 60,
  [SPORT_TYPES.baseball]: 180,
  [SPORT_TYPES.americanFootball]: 180,
  [SPORT_TYPES.rugby]: 95,
  [SPORT_TYPES.handball]: 90
}

export const EVENT_ATTENDANCE_MODE = {
  offline: "https://schema.org/OfflineEventAttendanceMode",
  online: "https://schema.org/OnlineEventAttendanceMode",
  mixed: "https://schema.org/MixedEventAttendanceMode"
}

export const PERSON_GENDER_INDEX = {
  unknown: 0,
  male: 1,
  female: 2,
  mixed: 3
}

export const PERSON_GENDER = {
  [PERSON_GENDER_INDEX.unknown]: 'Unknown',
  [PERSON_GENDER_INDEX.male]: 'Male',
  [PERSON_GENDER_INDEX.female]: 'Female',
  [PERSON_GENDER_INDEX.mixed]: 'Mixed'
}